let functionTimeoutHandler: NodeJS.Timeout = null;

export const debounce = (callback: Function, delay: number) => {
  if (functionTimeoutHandler) {
    clearTimeout(functionTimeoutHandler);
    functionTimeoutHandler = null;
  }

  functionTimeoutHandler = setTimeout(() => {
    callback();
  }, delay);
};
